import { apiFetch } from './client';

export interface AuditLogEntry {
  id: string;
  action: string;
  entityType: string;
  entityId: string | undefined;
  actor: string;
  details: Record<string, unknown> | undefined;
  ipAddress: string | undefined;
  createdAt: string;
}

export interface AuditLogFilters {
  action?: string;
  entityType?: string;
  actor?: string;
  dateFrom?: string;
  dateTo?: string;
  page?: number;
  limit?: number;
}

export interface AuditLogResponse {
  logs: AuditLogEntry[];
  total: number;
}

export const listAuditLogs = async (
  filters: AuditLogFilters = {},
): Promise<AuditLogResponse> => {
  const params = new URLSearchParams();

  if (filters.action) params.set('action', filters.action);
  if (filters.entityType) params.set('entityType', filters.entityType);
  if (filters.actor) params.set('actor', filters.actor);
  if (filters.dateFrom) params.set('dateFrom', filters.dateFrom);
  if (filters.dateTo) params.set('dateTo', filters.dateTo);
  if (filters.page !== undefined) params.set('page', String(filters.page));
  if (filters.limit !== undefined) params.set('limit', String(filters.limit));

  const query = params.toString();
  return apiFetch<AuditLogResponse>(`/audit${query ? `?${query}` : ''}`);
};

export interface AuditFacets {
  actions: string[];
  entityTypes: string[];
}

export const listAuditFacets = async (): Promise<AuditFacets> => {
  return apiFetch<AuditFacets>('/audit/facets');
};

export const getEntityAuditTrail = async (
  entityType: string,
  entityId: string,
): Promise<{ logs: AuditLogEntry[] }> => {
  return apiFetch<{ logs: AuditLogEntry[] }>(`/audit/${entityType}/${entityId}`);
};
